<ng-container [ngSwitch]="status">
    <kendo-chip
      *ngSwitchCase="InventoryStatus.OUT_OF_STOCK"
      rounded="full"
      themeColor="error"
      icon="cancel"
    >
    Out of Stock
    </kendo-chip>

    <kendo-chip
      *ngSwitchCase="InventoryStatus.HIGH_RISK"
      rounded="full"
      themeColor="inverse"
      icon="x-circle"
    >
    High Risk
    </kendo-chip>

    <kendo-chip
      *ngSwitchCase="InventoryStatus.MODERATE_RISK"
      rounded="full"
      themeColor="warning"
      icon="minus-circle"
    >
    Moderate Risk
    </kendo-chip>

    <kendo-chip
      *ngSwitchCase="InventoryStatus.WELL_STOCK"
      rounded="full"
      themeColor="success"
      icon="check-circle"
    >
    Well Stocked
    </kendo-chip>
</ng-container>